import { useCallback, useEffect, useRef, ChangeEvent } from 'react';

import { getDroppedOrSelectedFiles } from 'html5-file-selector';

const defaultOptions = {
  accept: '',
  multiple: true,
};

type FileInputCallback = (files: any[]) => void;

interface FileInputOptions {
  accept?: string;
  multiple?: boolean;
}

const useFileInput = (
  callback: FileInputCallback = () => {},
  options: FileInputOptions = {},
) => {
  const input = useRef(null);

  useEffect(() => {
    input.current = document.createElement('input');
    input.current.type = 'file';
  }, []);

  useEffect(() => {
    if (input.current) {
      const actualOptions = { ...defaultOptions, ...options };
      input.current.accept = actualOptions.accept || '';
      input.current.multiple = actualOptions.multiple;
    }
  }, [options && options.accept, options && options.multiple]);

  useEffect(() => {
    if (input.current) {
      input.current.onchange = (event: ChangeEvent) => {
        getDroppedOrSelectedFiles(event).then(list => {
          callback(list);
        });
      };
    }
  }, [callback]);

  return useCallback(() => {
    if (input.current) {
      // This is to allow the same file to be selected twice in a row.
      input.current.value = '';
      input.current.click();
    }
  }, [input.current]);
};

export default useFileInput;
